import { render, staticRenderFns } from "./PagesMenu.vue?vue&type=template&id=dc7d755a&scoped=true&"
import script from "./PagesMenu.vue?vue&type=script&lang=js&"
export * from "./PagesMenu.vue?vue&type=script&lang=js&"
import style0 from "./PagesMenu.vue?vue&type=style&index=0&id=dc7d755a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7d755a",
  null
  
)

export default component.exports